<template>
<div>
    <label class="label-modal">Deu sangue?</label>
    <v-radio-group :rules="RULES" v-model="MyObject.estado" row>
        <v-radio :color="$primary" label="Sim" value="1"></v-radio>
        <v-radio :color="$primary" label="Não" value="0"></v-radio>
    </v-radio-group>
</div>
</template>
<script>
import CRUD from '@/mixins/_CRUD'
export default {
    mixins: [CRUD],
    props: {
        MyObject: Object,
        RULES: Array,
    },
    data: () => ({
    }),
    computed: {
        getSession() {
            return this.$store.getters['session/getState']
        },
    },
    methods: {
    },
}
</script>
